import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { Container } from '../ui/Container';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const navigation = {
    product: [{
      name: 'Features',
      href: '/features'
    }, {
      name: 'Pricing',
      href: '/pricing'
    }],
    resources: [{
      name: 'Guides',
      href: '/resources'
    }, {
      name: 'Help',
      href: '/help'
    }],
    company: [{
      name: 'About',
      href: '/about'
    }, {
      name: 'Contact',
      href: '/contact'
    }],
    legal: [{
      name: 'Privacy',
      href: '/privacy'
    }, {
      name: 'Terms',
      href: '/terms'
    }, {
      name: 'EULA',
      href: '/eula'
    }, {
      name: 'Security',
      href: '/security'
    }],
    social: [{
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/useflowsense/',
      icon: (props: any) => <Linkedin {...props} data-id="element-111" />
    }]
  };
  return <footer className="bg-white border-t border-gray-200" aria-labelledby="footer-heading" data-id="element-112">
      <h2 id="footer-heading" className="sr-only" data-id="element-113">
        Footer
      </h2>
      <Container className="py-12 lg:py-16" data-id="element-114">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-115">
          <div className="space-y-8" data-id="element-116">
            <Link to="/" onClick={scrollToTop} className="flex items-center space-x-2" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/dPM9KUkaUrxRQPXFhc49CA/flowsense.png" alt="Flowsense" className="h-8 w-8" data-id="element-118" />
              <span className="text-xl font-bold text-gray-900" data-id="element-119">Flowsense</span>
            </Link>
            <p className="text-sm leading-6 text-gray-600 max-w-xs" data-id="element-120">
              Turn your Klaviyo flows into revenue machines with AI-powered
              insights and actionable recommendations.
            </p>
            <div className="flex space-x-6" data-id="element-121">
              {navigation.social.map(item => <a key={item.name} href={item.href} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-500" data-id="element-122">
                  <span className="sr-only" data-id="element-123">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" data-id="element-124" />
                </a>)}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" data-id="element-125">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-126">
              <div data-id="element-127">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-128">
                  Product
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-129">
                  {navigation.product.map(item => <li key={item.name} data-id="element-130">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-131">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-132">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-133">
                  Resources
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-134">
                  {navigation.resources.map(item => <li key={item.name} data-id="element-135">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-136">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-137">
              <div data-id="element-138">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-139">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-140">
                  {navigation.company.map(item => <li key={item.name} data-id="element-141">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-142">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-143">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-144">
                  Legal
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-145">
                  {navigation.legal.map(item => <li key={item.name} data-id="element-146">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-147">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24" data-id="element-148">
          <p className="text-xs leading-5 text-gray-500" data-id="element-149">
            &copy; 2025 Flowsense by Acciom Limited. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>;
}